import { css } from 'styled-components'

import { features } from './media'

const getContainerResponsiveWidths = ({ inDialog }) => {
  if (!inDialog) {
    return `
      @media (${features.minWidth.laptop}) {
        width: 750px;
      }
      @media (${features.minWidth.desktop}) {
        width: 970px;
      }
      @media (${features.minWidth.widescreen}) {
        width: 1170px;
      }
    `
  }
}
const base = css`
  font-family: proxima-nova, 'Proxima Nova', 'Montseratt', sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 10px;
  line-height: 1.15;
  box-sizing: border-box;

  &::before,
  &::after {
    box-sizing: border-box;
  }

  * {
    box-sizing: border-box;
  }
`
const vagRundFont = css`
  font-family: 'vag-rundschrift-d', 'Nunito', Helvetica, Arial, sans-serif;
`
const helveticaNeueFont = css`
  font-family: 'Helvetica Neue', Helvetica, sans-serif;
`
const museoFont = css`
  font-family: 'museo-sans-rounded', sans-serif;
`
const lists = css`
  ${base};
  margin: 0;
  padding: 0;
  line-height: normal;
  list-style-type: none;
  list-style-position: inside;
`
/**
 * These are resets taken from normalize.css.
 * Use these before the other mixins above.
 */
const formItemsReset = css`
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
`
const buttonReset = css`
  ${formItemsReset};
  overflow: visible;
  text-transform: none;
  /* stylelint-disable-next-line property-no-vendor-prefix */
  -webkit-appearance: button;
`
const h1Reset = css`
  font-size: 2em;
  margin: 0.67em 0;
`
const inputReset = css`
  ${formItemsReset};
  overflow: visible;
`
const selectReset = css`
  ${formItemsReset};
  text-transform: none;
`
const textareaReset = css`
  ${formItemsReset};
  overflow: auto;
`
const container = css`
  box-sizing: border-box;
  margin: 0 auto;
  padding: ${({ inDialog }) => (inDialog ? 0 : '0 15px')};
  background-color: ${({ bgColor }) => bgColor};
  ${getContainerResponsiveWidths};
`

export {
  base,
  vagRundFont,
  helveticaNeueFont,
  museoFont,
  lists,
  buttonReset,
  h1Reset,
  inputReset,
  selectReset,
  textareaReset,
  container
}
